<template>
    <section v-if="this.isReady" class="Section MyAccount">
                <div class="Container WhiteBox">
                    <div class="BoxWide">
                        <div class="Bookmark"><span>My account</span></div>
                    </div>
                    <div class="BoxWide"><div class="WhiteSpace">&nbsp;</div></div>
                </div>
                <div class="Container">
                    <div class="BoxWide">
                        <!-- Inizio visualizzazione -->
                        <form class="Form">
                            <fieldset>
                                <legend>Dati azienda</legend>
                                <div class="FormRow">
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Ragione Sociale</div>
                                            <div>{{this.azienda.RagioneSociale}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Partita Iva</div>
                                            <div>{{this.azienda.PartitaIva}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Telefono</div>
                                            <div>{{this.azienda.Telefono}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="FormRow">
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Indirizzo</div>
                                            <div>{{this.azienda.Indirizzo}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Località</div>
                                            <div>{{this.azienda.Localita}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Città</div>
                                            <div>{{this.azienda.Citta}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="FormRow">
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>CAP</div>
                                            <div>{{this.azienda.CAP}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Provincia</div>
                                            <div>{{this.azienda.Provincia}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Nazione</div>
                                            <div>{{this.azienda.Nazione}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="FormRow">
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Email</div>
                                            <div>{{this.azienda.Email}}</div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                        <!-- Fine visualizzazione -->
                    </div>
                </div>
                <div class="Container">
                    <div class="BoxWide">
                        <!-- Inizio visualizzazione -->
                        <form class="Form">
                            <fieldset>
                                <legend>Dati Utente</legend>
                                <div class="FormRow">
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Nome</div>
                                            <div>{{this.utente.Nome}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Cognome</div>
                                            <div>{{this.utente.Cognome}}</div>
                                        </div>
                                    </div>
                                    <div class="FormBox33">
                                        <div class="FormResumeData">
                                            <div>Email</div>
                                            <div>{{this.utente.Email}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="FormRow">
                                </div>
                            </fieldset>
                        </form>
                        <!-- Fine visualizzazione -->
                    </div>
                </div>
                <div class="Container">
                    <div class="BoxWide"><div class="WhiteSpace Stroked">&nbsp;</div></div>
                </div>
                <div class="Container">
                    <div class="BoxWide">
                        <!-- Inizio modifica -->
                        <form class="Form">
                            <fieldset>
                                <legend>Modifica password</legend>
                                <div class="FormRow">
                                    <div class="FormBox33">
                                        <label>Vecchia pasword</label>
                                        <input type="password" id="" name="" placeholder="Old Password" v-model="this.oldPsw">
                                    </div>
                                    <div class="FormBox33">
                                        <label>Nuova password</label>
                                        <input type="password" id="" name="" placeholder="New Passord" v-model="this.newPsw">
                                    </div>
                                    <div class="FormBox33">
                                        <label>Conferma password</label>
                                        <input type="password" id="" name="" placeholder="Repeat new Password" v-model="this.repPsw">
                                    </div>
                                </div>
                                <div class="FormRow">
                                    <div class="FormBoxWide">
                                        <div class="TwinButtons">
                                            <div class="Button Small">
                                                <input type="button" id="" name="" value="Annulla" @click="this.resetPsw">
                                            </div>
                                            <div class="Button Small">
                                                <input type="button" id="" name="" value="Modifica password" @click="this.changePassword">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                        <!-- Fine modifica -->
                        <!-- <form class="Form">
                            <div class="FormRow">
                                <div class="FormBoxWide"><div class="Alert Good">
                                    <div class="AlertTitle">Complimenti! Tutto è andato bene!</div>
                                    <div class="AlertText">A breve riceverai una e-mail con i  dati del tuo ordine etc.etc.</div>
                                </div>

                                <div class="Alert Bad">
                                        <div class="AlertTitle">Ops! Qualcosa è andato storto</div>
                                        <div class="AlertText">Qualcosa nella trasmissione dell'ordine è andato storto. Ti preghiamo di riprovare etc.etc.</div>
                                    </div>
                                </div>
                            </div>
                        </form> -->
                    </div>
                </div>
            </section>
</template>

<script>

import { apiMixin } from "/mixin.js"

export default {
    name: "MyAccount",
    mixins: [apiMixin],

    data(){
        return{
            azienda: null,
            utente: null,
            isReady: false,

            //Psw Fileds
            oldPsw: "",
            newPsw: "",
            repPsw: ""
        }
    },
    mounted: function(){
        this.utente = this.$store.getters.getUtente.DettagliUtente.DatiUtente;
        this.azienda = this.$store.getters.getUtente.DettagliUtente.DatiAzienda;
        this.isReady = true;
    },
    methods:{
        changePassword: function(){
            if (this.oldPsw.length < 1 || this.newPsw.length < 1 || this.repPsw < 1){
                this.$toast.error("Attenzione! Inserire inserire tutti i dati e riprovare!", {position:"top-right"});
                return;
            }
            else if(this.newPsw != this.repPsw){
                this.$toast.error("Attenzione! La password devono coincidere!", {position:"top-right"});
                return;
            }
            else{
                
                let data = {
                    oldPassword: this.oldPsw,
                    newPassword: this.newPsw
                };

                this.doApiCall("post", "utenti/cambiopassword", this.$store.getters.getUtente.Token, null, data).then(

                    (data) => {  
                        if(data && data.StatusCode === 200){                    
                            this.$toast.success("Password aggiornata con successo!", {position:"top-right"});
                            this.resetPsw();
                        }
                        else{
                            this.$toast.error("Attenzione! Si sono verificati errori durante l'aggiornamento della password!", {position:"top-right"});
                        }
                    }
                );
            }
        },
        resetPsw: function(){
            this.oldPsw = "";
            this.newPsw = "";
            this.repPsw = "";
        }
    }
}
</script>
